// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3U5uv","column":"style_column__1xhnC"};